import { FilterInfo } from "./filter-info";

export class PressFilterInfo extends FilterInfo {
    constructor(options = {}) {
        // Set default options for wiki filter
        const pressOptions = {
            queryId: "press-listing",
            perPage: 12,
            showingSelector: ".press__showing",
            totalSelector: ".press__total",
            hasSearchSummary: false,
            modifyInputValue: true,
            searchOptions: {
                categorySelectSelector: '.cat-filter .jet-radio-list__input',
                categoryTaxName: 'press-category'
            },
        };

        // Merge with any user-provided options
        super({ ...pressOptions, ...options });

    }
}
